import { User } from 'oidc-client'

const getSub = (user: User): string => (!user || !user.profile || !user.profile.sub ? '' : user.profile.sub)

export function updateDataLayerUserId(user: User) {
  const userSub = getSub(user)

  if (typeof window !== 'undefined') {
    const dl = window.adobeData
    if (dl && dl.page && dl.page.user) {
      dl.page.user.aaId = userSub
    }
  }

  return user
}
